module.exports = __webpack_public_path__ + "static/img/8.3d0b8a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/8.png
// module id = jxMh
// module chunks = 0